import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import * as chatActions from 'modules/chat';

import util from 'util/baseUtil';

import WAVECHAT from 'lib/wavechat';

const SocketChat = () => {
  
  const activeChannel = useSelector(state => state.chat.activeChannel);
  const dispatch = useDispatch();

  /* 웹소켓 데이터 수신 핸들러 */
  useEffect(() => {
    WAVECHAT.onmessage = (data) => {

      switch(data.ptc) {
        case WAVECHAT.PacketTypes.PTC_COP_MSG_CONTROL:    //메시지 컨트롤 수신
          // console.log('모이미 웹 게시 숨김 호출',data);
          dispatch(chatActions.msgControl(data));
          break;
        case WAVECHAT.PacketTypes.PTC_IMS_CHAT_RECV_MSG:    //채팅 메시지 수신
          let chat = util.convertAttrToUnderscore(data);
          chat.cid = data.cId;
          // console.log('모이미 챗',chat);
    
          if (activeChannel.room_id && activeChannel.room_id !== chat.room_id) {
            return;
          }
          if (chat.room_id.indexOf('STOCK_') === 0) {
            return;
          } 
          if (chat.web_post_yn !== 'Y') {
            return;
          }
          dispatch(chatActions.prependChatList([chat]));
          dispatch(chatActions.updateUserCount(chat));
          break;
        default:
      }
    };
    
  },[dispatch, activeChannel.room_id, activeChannel.tabChannel]);


  /* 웹소켓 초기 작업 및 종료 작업 */
  useEffect(() => {
    WAVECHAT.debug = false;
    WAVECHAT.open();
    return () => {
      WAVECHAT.close();
    }
  },[]);



  return (
    <>
    </>
  )
}

export default SocketChat;